var $951123009890117d$exports = {};
$951123009890117d$exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`
};


export {$951123009890117d$exports as default};
//# sourceMappingURL=en-US.mjs.map
